<template>  
  <ValidationObserver v-slot="{ invalid, handleSubmit}" tag="div">
    <form ref="form" method="POST" @submit.prevent="handleSubmit(onSubmit)" class="contactform" spellcheck="false" :class="{disabled: sending || sent}">
      <ValidationProvider name="name" rules="required" tag="div" class="inputrow" v-slot="{ errors }">
        <input v-model="form.name" name="name" type="text" :class="{hasError: errors[0]}" novalidate placeholder="name" autocomplete="off" :disabled="sending || sent">
        <label for="name"><span>your</span>name</label>
        <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
      </ValidationProvider>

      <ValidationProvider name="email" rules="required" tag="div" mode="eager" class="inputrow" v-slot="{ errors }">
        <input v-model="form.email" name="email" type="email" :class="{hasError: errors[0]}" novalidate placeholder="email" :disabled="sending || sent">
        <label for="email"><span>your</span> email</label>
        <span class="errormessage" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
      </ValidationProvider>

      <ValidationProvider name="message" rules="required" tag="div" class="inputrow" v-slot="{ errors }">
        <textarea v-model="form.message" name="message" type="text" :class="{hasError: errors[0]}" novalidate placeholder="message" :disabled="sending || sent" />
        <label for="message"><span>your</span> message</label>
        <span class="errormessage text" :class="{hasError: errors[0]}">{{ errors[0] }}</span>
      </ValidationProvider>

      <div class="inputrow potterhoneeey">
        <input v-model="form.potterhoneeey" name="potterhoneeey" autocomplete="off" type="text" novalidate :disabled="sending || sent">
      </div>

      <button type="submit" :disabled="sending || sent">{{buttonText}}
        <div class="spinner" v-if="sending">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </button>

      <Snackbar ref="snackbar" />
    </form>
  </ValidationObserver>  
</template>

<script>
import { required, email } from 'vee-validate/dist/rules.umd';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import axios from 'axios';
import Snackbar from '@/components/Snackbar.vue';

extend('email', {...email, message: "Please provide a valid email address."});
extend('required', {...required, message:'Your {_field_} is required.'});

export default {
  name: 'ContactForm',
  data: function(){
    return {
      form: {
        name: '',
        email: '',
        message: '',
        potterhoneeey: ''
      },
      sending: false,
      sent: false,
      onlylocaldebug: false, //true,
      userecaptcha: false,
      scriptRoot: 'https://script.google.com/macros/s/',
      macro: process.env.VUE_APP_CONTACT_FORM
    }
  },
  computed: {
    buttonText: function(){
      return this.sending ? '' : (this.sent ? 'We got your message!' : 'SEND');
    }
  },
  methods: {
    onSubmit: async function() {

      if(this.form.potterhoneeey)
        return;

      this.sending = true; 

      let bodyFormData = new FormData();
      bodyFormData.append('name', this.form.name);
      bodyFormData.append('email', this.form.email);
      bodyFormData.append('message', this.form.message);      

      if(this.userecaptcha){
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('contact');
        // include token in the call to send shit, verify, etc... for now not needed
        console.log(token);
      }

      if(this.onlylocaldebug)
        setTimeout(() => { this.sending = false; this.sent = true; this.$refs.snackbar.show("Message sent") }, 2000);      
      else{
          await axios({
            method: 'post',
            url: this.scriptRoot + this.macro, 
            data: bodyFormData,
            headers: {'Content-Type': 'application/x-www-form-urlencoded' },
            maxRedirects: 0
          })
          .then((/*res*/) => {                    
            this.sent = true;
            this.$refs.snackbar.show('Message sent');
          })
          .catch((error) => {
            // error.response.status Check status code
            this.$refs.snackbar.show("Ooops, couldn't send message :( please retry!", 5000);
            //console.log('contact form sending error: ' + error);
            this.appInsights.trackException({exception: new Error(error)});
          })
          .finally(() => {
            this.sending = false;
          }); 
          
          this.appInsights.trackEvent({name: "ContactForm", properties: {name: this.form.name, email: this.form.email, message: this.form.message}});
        }     
     }
  },
  components: {
    ValidationProvider, 
    ValidationObserver,
    Snackbar
  }
}
</script>

<style lang="scss">
.contactform{
  max-width: 500px;
  margin: 0 auto;
  padding: 0 30px;

  .potterhoneeey{
    display: none;
  }

  &.disabled .inputrow{
    opacity: 0.3;
  }

  .inputrow{
    min-height: 70px;
    position: relative;
    margin-bottom: 10px;

    span.errormessage{
      display: block;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: var(--color-error);
      font-family: Averia, Cambria;
      opacity: 0;

      &.hasError{
        opacity: 1;
        transition: opacity 0.5s;
      }

      // &:after{
      //   content: '';
      //   position: relative;
      //   width: 100%;
      //   top: -21px;
      //   display: block;
      //   border-bottom: 1px dashed white;
      //   //border-bottom: 1px solid $orange;
      //   transform-origin: center;
      //   transition: transform 0.2s ease;
      //   transform: scaleX(0);     
      // }

      // &.text:after{
      //   //top: -26px;
      // }
    }

    label{
      font-family: Averia, Cambria;
      position: absolute;
      color: #a0a0a0;
      left: 0;
      top: -20px;
      font-size: 18px;  
      opacity: 0.5;
      z-index: -1;
      transform: scale(1);
      transform-origin: left;

      span{
        max-width: 0;
        display: block;
        float: left;
        overflow: hidden;
        padding-right: 0;
      }
    }
  }

  // chrome autocomplete hack
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {    
    background-color: transparent;   
    box-shadow: 0 0 0 30px var(--color-bg) inset !important;
    -webkit-box-shadow: 0 0 0 30px var(--color-bg) inset !important;
    -webkit-text-fill-color: var(--color-contact-input-text);
  }

  input, textarea{ 
    width: 100%;
    border: none;
    border-bottom: 1px solid var(--color-contact-input-border); //rgba($color: #a0a0a0, $alpha: 0.5);
    //border-bottom: 1px dashed #a0a0a0;
    font-family: 'Courier New', Courier, monospace;    
    outline: none;
    resize: vertical;
    transition: border-color 0.5s ease;
    padding: 0;   
    background: transparent;   
    user-select: none;  
    color: var(--color-contact-input-text);

    &::placeholder {
      color: transparent;
    }

    &:placeholder-shown ~ label {
      cursor: text;
      top: 0px;
      //font-size: 16px;
      transform: scale(0.88);
      transform-origin: left;

      span{
        max-width: 40px;
        padding-right: 5px;
      }
    }

    &.hasError{
      color: var(--color-error);
      // border-bottom-color: var(--color-error);
      // &:focus{
      //   border-bottom-color: var(--color-error);
      // }
      //font-weight: bold;
    }

    &:focus{
      outline: none;
      //border-bottom: 1px solid #a0a0a0;

      ~ label {
        top: -20px;
        opacity: 1;  
        transform: scale(1);
        transform-origin: left;   

        span{
          max-width: 0;
          padding-right: 0;
        }     
      }
    }

    // &:focus ~ span.errormessage:after {      
    //     transform: scaleX(1);      
    // }
  }

  input{
    font-size: 18px;
    height: 25px;       
  }

  textarea{
    min-height: 75px;
    font-size: 14px;
    padding-top: 5px;    
  }

  button{
    width: 100%;
    height: 45px;
    border: none;
    background-color: var(--color-button-bg);
    cursor: pointer;
    line-height: 45px;
    border-radius: 5px;
    outline: none;
    position: relative;
    font-family: Averia, 'courier new';
    user-select: none;

    &[disabled]{
      font-family: unset;
    }

    &:hover{
      background-color: var(--color-button-bg-hover);
      color: $orange;
    }

    &:active{
      background-color: $orange;
      color: white;
    }
  }  

}
</style>
